import { Paper, Stack, Text, Alert } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IconInfoCircle } from '@tabler/icons-react';

interface GbaseProjectProps {
  authorized?: boolean;
  loading?: boolean;
}

export const GbaseProject: React.FC<GbaseProjectProps> = ({ authorized = false, loading = false }) => {
  const { t } = useTranslation();

  return (
    <div className="mt-4 mb-4 p-6 rounded-lg" style={{ backgroundColor: '#f0f0ff' }}>
      <Stack gap="md">
        {/* 功能说明标题和描述 */}
        <div>
          {/* <Text size="15px" fw={600} className="text-gray-800 mb-3">
            {t('create_v2.integrations.data_sources.gbase_project.feature_title')}
          </Text> */}
          <Text size="14px" className="text-gray-700 leading-relaxed mb-2">
            {t('create_v2.integrations.data_sources.gbase_project.feature_description')}
          </Text>
        </div>

        {/* 使用前提高亮区域 */}
        <div
          className="p-4 rounded border-l-4"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            borderLeftColor: '#6d5dfc',
          }}
        >
          <Text size="15px" fw={600} className="text-gray-800 mb-2">
            💡 {t('create_v2.integrations.data_sources.gbase_project.prerequisite_title')}
          </Text>
          <Text size="14px" className="text-gray-700 leading-relaxed" style={{ marginBottom: 0 }}>
            {t('create_v2.integrations.data_sources.gbase_project.prerequisite_line1')}{' '}
            <span style={{ color: '#6d5dfc', fontWeight: 600 }}>GBase</span>{' '}
            {t('create_v2.integrations.data_sources.gbase_project.prerequisite_line1_suffix')}
            <br />
            {t('create_v2.integrations.data_sources.gbase_project.prerequisite_line2')}
          </Text>
        </div>

        {/* 授权状态提示 */}
        {!loading && authorized && (
          <Alert icon={<IconInfoCircle size={16} />} /* title={t('gbase.authorization_status_title')} */ color="blue">
            {t('gbase.authorized_message')}
          </Alert>
        )}
      </Stack>
    </div>
  );
};
